/*
 * Compares two semantic version strings (e.g., "1.2.3" vs "1.2.4").
 *
 * @param {string} a - The first semantic version string.
 * @param {string} b - The second semantic version string.
 * @returns {number} Returns:
 *   - `1` if version `a` is greater than version `b`,
 *   - `-1` if version `a` is less than version `b`,
 *   - `0` if both versions are equal up to the length of the shorter version.
 *
 * @example
 * compareSemanticVersions("1.2.3", "1.2.4"); // returns -1
 * compareSemanticVersions("2.0", "1.9.9");   // returns 1
 * compareSemanticVersions("1.0", "1.0.0");   // returns 0
 */
export const compareSemanticVersions = (a: string, b: string): number => {
    const aParts = a.split('.').map((part) => parseInt(part, 10) || 0);
    const bParts = b.split('.').map((part) => parseInt(part, 10) || 0);

    const maxLength = Math.max(aParts.length, bParts.length);

    for (let i = 0; i < maxLength; i++) {
        const aVal = aParts[i] ?? 0;
        const bVal = bParts[i] ?? 0;

        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
    }

    return 0;
};
